export const multipleBrickFormDefaults = {
  name: "",
  user: null,
  description: "",
  checklists: [],
  multipleDates: [],
};
